import { createFileRoute } from '@tanstack/react-router';
import { ProjectDetail } from '../../../screens/ProjectDetail';

export const Route = createFileRoute('/tasks/projects/$id')({
  component: ProjectDetail,
});
